import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const FutureReadySolutions = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h1 className="banner-title">Future-Ready Solutions</h1>
          <p>
            Stay ahead of the curve with our cutting-edge solutions designed to
            future-proof your business. <br /> Leverage emerging technologies
            like AI, IoT, blockchain, and cloud computing to build a resilient,
            scalable, and sustainable future.
          </p>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/young-man-wearing-virtual-reality-goggles_23-2148815719.jpg"
          alt="Future-Ready Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="text-center">Overview</h2>
              <p className="text-center">
                Our future-ready solutions help businesses embrace the latest
                technologies and trends. By integrating AI, automation, and
                advanced analytics, we ensure that your organization is prepared
                to tackle tomorrow’s challenges, today.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid bg-light" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Case Studies</h2>
              <p className="text-center mb-0">
                Explore real-world examples of how our future-ready solutions
                have helped businesses thrive in an ever-evolving digital
                landscape.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">
                AI-Powered Predictive Maintenance
              </h4>
              <p className="mb-4">
                By utilizing AI-powered predictive maintenance, we helped an
                industrial manufacturing company reduce downtime by 40%. The
                system used sensors and data analytics to predict equipment
                failures before they occurred, saving on repair costs and
                increasing productivity.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">Cloud-Based Data Security</h4>
              <p className="mb-4">
                We implemented a comprehensive cloud-based security solution for
                a financial institution, ensuring compliance with data privacy
                regulations while enhancing security. This cloud infrastructure
                increased data access speed by 50%, reduced IT costs, and
                improved security across multiple platforms.
              </p>
            </div>
          </div>
        </div>
      </div>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 bg-black text-white mx-0 px-4">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2>Ready to Embrace the Future?</h2>
                <p className="mt-3">
                  Connect with us to explore how we can help you adopt
                  next-generation technologies for a sustainable and
                  future-proof business.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/technology-background-with-blockchain-concept_23-2148738266.jpg"
                        className="w-100"
                        alt="Future Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FutureReadySolutions;
